import { Book, Calendar, Clock, Phone, User, Users } from 'assets/Icons'
import Money from 'assets/Icons/Sidebar/Money'
import { prettyDateTimeHour, prettyPrice } from 'helpers/prettyData'
import { Fragment } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { weekDayName } from '../helpers'

const Card = ({
	id,
	name = '',
	weekdays = [],
	price = 0,
	start_time = '',
	end_time = '',
	teachers = null,
	students = [],
	students_count = 0,
}) => {
	const navigate = useNavigate()
	const role = useSelector(state => state?.user?.user?.user_type)
	return (
		<div
			className='col-span-12 sm:col-span-6 lg:col-span-4 border-[#E4E4E4] dark:border-[#FFFFFF33] border-[1px] rounded-[15px]  bg-[linear-gradient(0deg,#FFFFFF,#FFFFFF),linear-gradient(97.29deg,rgba(161,158,158,0.15)_-0.29%,rgba(255,255,255,0)_51.75%,rgba(161,158,158,0.15)_102.8%)] dark:bg-[linear-gradient(0deg,rgba(171,171,171,0.03),rgba(171,171,171,0.03)),linear-gradient(98.23deg,rgba(255,255,255,0.13)_-1.89%,rgba(73,73,73,0)_51.47%,rgba(255,255,255,0.13)_104.51%)] backdrop-filter-[blur(7px)] cursor-pointer'
			onClick={() => navigate(`/account/groups/${id}`)}
		>
			{role !== 'student' ? (
				<div className='flex items-center justify-between p-4 md:p-6'>
					<div className='col-span-6 flex flex-col gap-4'>
						<div className='flex items-center gap-3'>
							<span className='text-[#018ECC]'>
								<Book />
							</span>
							<p className='text-[14px] md:text-[16px] text-[#292A32] dark:text-[#FFFFFF] font-semibold'>
								{name}
							</p>
						</div>
						{teachers?.first_name && (
							<div className='flex items-center gap-3'>
								<span className='text-[#018ECC]'>
									<User />
								</span>
								<p className='text-[14px] md:text-[16px] text-[#292A32] dark:text-[#FFFFFF] font-semibold'>
									{teachers?.first_name + ' ' + teachers?.last_name}
								</p>
							</div>
						)}
						<div className='flex items-center gap-3'>
							<span className='text-[#018ECC]'>
								<Calendar />
							</span>
							<p className='text-[14px] md:text-[16px] text-[#5E5C5C] dark:text-[#FFFFFF] font-medium'>
								{weekdays?.map(item => (
									<span className='me-2'>{weekDayName(item)}</span>
								))}
							</p>
						</div>
						<div className='flex items-center gap-3'>
							<span className='text-[#018ECC]'>
								<Clock />
							</span>
							<p className='text-[14px] md:text-[16px] text-[#5E5C5C] dark:text-[#FFFFFF] font-medium'>
								{prettyDateTimeHour(start_time)} -{' '}
								{prettyDateTimeHour(end_time)}
							</p>
						</div>
					</div>
					<div className='col-span-6'>
						<div className='flex items-center gap-4'>
							<span className='text-[#018ECC]'>
								<Users />
							</span>
							<h4 className='text-[20px] md:text-[24px] text-[#292A32] dark:text-[#FFFFFF] font-semibold'>
								{students_count}
							</h4>
						</div>
					</div>
				</div>
			) : (
				<div className='flex items-center justify-between p-4 md:p-5'>
					<div className='col-span-6 flex flex-col gap-4'>
						<div className='flex items-center gap-3'>
							<span className='text-[#018ECC]'>
								<Book />
							</span>
							<p className='text-[14px] md:text-[16px] text-[#292A32] dark:text-[#FFFFFF] font-semibold'>
								{name}
							</p>
						</div>
						{teachers?.first_name && (
							<Fragment>
								<div className='flex items-center gap-3'>
									<span className='text-[#018ECC]'>
										<User />
									</span>
									<p className='text-[14px] md:text-[16px] text-[#292A32] dark:text-[#FFFFFF] font-semibold'>
										{teachers?.first_name + ' ' + teachers?.last_name}
									</p>
								</div>
								<div className='flex items-center gap-3'>
									<span className='text-[#018ECC]'>
										<Phone />
									</span>
									<p className='text-[14px] md:text-[16px] text-[#292A32] dark:text-[#FFFFFF] font-semibold'>
										{teachers?.phone_number}
									</p>
								</div>
							</Fragment>
						)}
					</div>
					<div className='col-span-6 flex flex-col gap-4'>
						<div className='flex items-center gap-3'>
							<span className='text-[#018ECC]'>
								<Money />
							</span>
							<p className='text-[14px] md:text-[16px] text-[#5E5C5C] dark:text-[#FFFFFF] font-medium'>
								{prettyPrice(price)} so'm
							</p>
						</div>
						<div className='flex items-center gap-3'>
							<span className='text-[#018ECC]'>
								<Calendar />
							</span>
							<p className='text-[14px] md:text-[16px] text-[#5E5C5C] dark:text-[#FFFFFF] font-medium'>
								{weekdays?.map(item => (
									<span className='me-2'>{weekDayName(item)}</span>
								))}
							</p>
						</div>
						<div className='flex items-center gap-3'>
							<span className='text-[#018ECC]'>
								<Clock />
							</span>
							<p className='text-[14px] md:text-[16px] text-[#5E5C5C] dark:text-[#FFFFFF] font-medium'>
								{prettyDateTimeHour(start_time)} -{' '}
								{prettyDateTimeHour(end_time)}
							</p>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}

export default Card
